import React from "react";
interface Props {
  className?: string;
}
function RightArrowAccordian({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //   width="11"
      //   height="14"
      className={className}
      fill="none"
      viewBox="0 0 27 22"
    >
      <path
        fill="#262626"
        d="M15.11.477a.562.562 0 000 .796l9.165 9.164H.883a.563.563 0 000 1.125h23.392l-9.165 9.165a.563.563 0 00.796.796l10.125-10.125a.563.563 0 000-.796L15.906.477a.563.563 0 00-.796 0z"
      ></path>
    </svg>
  );
}

export default RightArrowAccordian;
